import { render, staticRenderFns } from "./index_banner.vue?vue&type=template&id=4955bc1d&scoped=true&"
import script from "./index_banner.vue?vue&type=script&lang=js&"
export * from "./index_banner.vue?vue&type=script&lang=js&"
import style0 from "./index_banner.vue?vue&type=style&index=0&id=4955bc1d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955bc1d",
  null
  
)

export default component.exports